// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TalFooterWrap{display:flex;box-sizing:border-box;background:#d1e1f2!important;justify-content:flex-start;text-align:left;width:100%;height:60px;z-index:99}.footerRouter{-webkit-text-decoration-line:none;text-decoration-line:none}.footerRouter img{width:1.4rem}p{margin-bottom:0;color:#7e7e7e}.activeFooterMenu{font-weight:bolder;color:#4a669e!important}", ""]);
// Exports
module.exports = exports;
